<template>
	<div class="success-tip" v-if='isShowsuccess'>
		<img class="icon-tips" src="../../../static/success-icon.png"  alt="">
		<span class="icon-title">投诉已提交</span>
		<span class="icon-text">我们会尽快核实处理，感谢<br>您对平台的支持</span>
		<span class="subbtn" @click="returnBack">确定</span>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		data(){
			return{
				isShowsuccess:false
			}
		},
		methods:{
			handleShow(){
				this.isShowsuccess=true;
			},
			returnBack(){
				this.$router.go(-1)
			}
		}
		
	}
</script>

<style scoped>
.success-tip>span{
	display: block;
}
	.success-tip{
		background-color: #FFFFFF;
        text-align: center;
		position: fixed;
		left:0px;
		top:0px;
		width: 100%;
		height: 100%;
		z-index: 9999;
	}
	.icon-tips{
		width: 50px;
		height: 50px;
		margin-top: 99px;
	}
	.icon-title{
		font-size: 22px;
		color: #333333;
		font-weight: bold;
        margin-top:45px;
		margin-bottom:20px;
	}
	.icon-text{
		font-size: 16px;
		color: #333333;
		letter-spacing: 0;
		text-align: center;
		line-height: 24px;
		font-weight: bold;
		margin-bottom:45px;
	}
	text{
		display: block;
	}
	.subbtn{
		background: #2EC159;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 15px;
		color: #FFFFFF;
		letter-spacing: 4px;
		text-align: center;
		width: 180px;
		height: 44px;
		line-height: 44px;
		margin:0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/view/bookComplaint/success.vue